import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calendar as CalendarIcon, User } from 'lucide-react';
import { COLUMNAS, PRIORIDADES } from '@/utils/tareaUtils';

export default function VistaCalendario({ tareas, onViewDetail }) {
  const tareasPorFecha = tareas
    .filter(t => t.fecha_planificada)
    .sort((a, b) => new Date(a.fecha_planificada) - new Date(b.fecha_planificada))
    .reduce((acc, tarea) => {
      const fecha = tarea.fecha_planificada;
      if (!acc[fecha]) acc[fecha] = [];
      acc[fecha].push(tarea);
      return acc;
    }, {});

  return (
    <Card>
      <CardHeader>
        <CardTitle>Vista de Calendario - Tareas por Fecha</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {Object.entries(tareasPorFecha).map(([fecha, tareasDelDia]) => {
            const fechaObj = new Date(fecha);
            const esHoy = new Date().toDateString() === fechaObj.toDateString();
            const esVencida = fechaObj < new Date() && !esHoy;
            
            return (
              <div key={fecha} className={`p-4 rounded-lg border-l-4 ${
                esHoy ? 'border-emerald-500 bg-emerald-50' : 
                esVencida ? 'border-red-500 bg-red-50' : 
                'border-blue-500 bg-blue-50'
              }`}>
                <h3 className="font-bold mb-2 flex items-center">
                  <CalendarIcon className="w-5 h-5 mr-2" />
                  {fecha}
                  {esHoy && <Badge className="ml-2 bg-emerald-600">Hoy</Badge>}
                  {esVencida && <Badge className="ml-2 bg-red-600">Vencida</Badge>}
                  <Badge className="ml-2" variant="secondary">{tareasDelDia.length}</Badge>
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                  {tareasDelDia.map(tarea => (
                    <div 
                      key={tarea.id} 
                      className="bg-white p-3 rounded shadow-sm hover:shadow-md transition cursor-pointer"
                      onClick={() => onViewDetail(tarea)}
                    >
                      <div className="flex justify-between items-start mb-1">
                        <h4 className="font-semibold text-sm">{tarea.titulo}</h4>
                        <Badge className={`text-xs ${PRIORIDADES[tarea.prioridad].color}`}>
                          {PRIORIDADES[tarea.prioridad].icon}
                        </Badge>
                      </div>
                      <p className="text-xs text-gray-600">
                        {COLUMNAS.find(c => c.id === tarea.estado)?.titulo}
                      </p>
                      {tarea.responsable_nombre && (
                        <p className="text-xs text-gray-500 flex items-center mt-1">
                          <User className="w-3 h-3 mr-1" />
                          {tarea.responsable_nombre}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
          
          {tareas.filter(t => t.fecha_planificada).length === 0 && (
            <p className="text-center text-gray-500 py-8">
              No hay tareas con fecha planificada
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
